module.exports = __webpack_public_path__ + "img/nav-right-search-below-honda.3e78a2d9.png";